import { Component, NgModule, OnDestroy, OnInit } from '@angular/core';
import { BaseReportTableComponent } from '../../../../components/base-report-table/base-report-table.component';
import { SimpleReportTableColumn } from '../../../../components/report-filters/models/report-data.model';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { TableStructure } from '@shared/components/table/models/table-structure.model';
import { SurgeryStatsReportRecord } from '../../surgery-stats-report.model';
import { SimpleReportTableComponentModule } from '@src/app/features/reports/components/simple-report-table/simple-report-table.component';
import { SimpleReportTableComponent } from '../../../../components/simple-report-table/simple-report-table.component';
import { EmptyTableStateComponent } from '@shared/components/empty-table-state/empty-table-state.component';
import { ReportType } from '@src/app/features/reports/components/report-filters/models/report-filters.model';

@Component({
  selector: 'stx-surgery-stats-report-table',
  templateUrl: './surgery-stats-report-table.component.html',
  imports: [MatPaginator, SimpleReportTableComponent, EmptyTableStateComponent]
})
export class SurgeryStatsReportTableComponent extends BaseReportTableComponent<SurgeryStatsReportRecord> implements OnInit, OnDestroy {
  readonly reportType: ReportType = 'SURGERY_STATS';

  displayedColumns: string[] = [];
  columns: SimpleReportTableColumn[] = [];
  constructor() {
    super();
  }

  ngOnInit(): void {
    super.onInit();
    this.subSink.sink = this.reportTableDataService.tableStructure$.subscribe(
      (tableStructure: TableStructure<SurgeryStatsReportRecord[]>) => {
        this.columns = tableStructure?.labels || [];
        this.displayedColumns = this.columns.map(a => a.name);
      }
    );
  }

  ngOnDestroy(): void {
    super.onDestroy();
  }
}

@NgModule({
  imports: [
    MatTableModule,
    MatSortModule,
    TranslateModule,
    CommonModule,
    MatIconModule,
    MatPaginatorModule,
    SimpleReportTableComponentModule,
    SurgeryStatsReportTableComponent
  ],
  exports: [SurgeryStatsReportTableComponent]
})
export class SurgeryStatsReportTableComponentModule {}
